import { Box, Container, Grid, Typography } from '@mui/material';
import { useAuth } from '../../../hooks/use-auth';
import { useMounted } from '../../../hooks/use-mounted';
import { SatisfactionQuestionnaireList } from './satisfactionQuestionnaireList';
import { useCallback, useEffect, useState } from 'react';
import { surveyApi } from '../../../api/survey-api';
import { gtm } from '../../../lib/gtm';

const Satisfaction = () => {
  const isMounted = useMounted();
  const [questionnaires, setQuestionnaires] = useState([])
  const { user } = useAuth(); 

  const getQuestionnaires = useCallback(async () => {
    try {
      const data = await surveyApi.getAllSurvey(user.admin_id)
      if (isMounted()) {
        setQuestionnaires(data);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMounted]);

  useEffect(() => {
    getQuestionnaires();
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
    <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 11
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 5 }}>
            <Grid
              container
              justifyContent="space-between"
              spacing={3}
            >
              <Grid item>
                <Typography variant="h4" sx={{fontFamily: "Montserrat"}}>
                  Questionnaires de satisfaction
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Grid
              container
              spacing={4}
            >
              <Grid
                item
                xs={12}
              >
                <SatisfactionQuestionnaireList
                  questionnaires = {questionnaires}
                  setQuestionnaires = {setQuestionnaires}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};


export default Satisfaction;
